export const imports = {
  'components/GettingStarted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-getting-started" */ 'components/GettingStarted.mdx'
    ),
  'components/Overview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-overview" */ 'components/Overview.mdx'
    ),
  'components/common/ContentEditable.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-common-content-editable" */ 'components/common/ContentEditable.mdx'
    ),
  'components/discussions/DateBanner.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-discussions-date-banner" */ 'components/discussions/DateBanner.mdx'
    ),
  'components/discussions/Discussion.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-discussions-discussion" */ 'components/discussions/Discussion.mdx'
    ),
  'components/discussions/DiscussionForm.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-discussions-discussion-form" */ 'components/discussions/DiscussionForm.mdx'
    ),
  'components/table/Table.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-table-table" */ 'components/table/Table.mdx'
    ),
  'components/core/bridge_model/BridgeModel.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-bridge-model-bridge-model" */ 'components/core/bridge_model/BridgeModel.mdx'
    ),
  'components/core/attribute_definition/AttributeDefinition.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-attribute-definition-attribute-definition" */ 'components/core/attribute_definition/AttributeDefinition.mdx'
    ),
  'components/core/category/Category.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-category-category" */ 'components/core/category/Category.mdx'
    ),
  'components/core/core_form/CoreForm.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-core-form-core-form" */ 'components/core/core_form/CoreForm.mdx'
    ),
  'components/core/form/Form.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-form-form" */ 'components/core/form/Form.mdx'
    ),
  'components/core/form_type/FormType.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-form-type-form-type" */ 'components/core/form_type/FormType.mdx'
    ),
  'components/core/i18n/i18n.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-i18n-i18n" */ 'components/core/i18n/i18n.mdx'
    ),
  'components/core/index_definition/IndexDefinition.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-index-definition-index-definition" */ 'components/core/index_definition/IndexDefinition.mdx'
    ),
  'components/core/index_job/IndexJob.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-index-job-index-job" */ 'components/core/index_job/IndexJob.mdx'
    ),
  'components/core/kapp/Kapp.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-kapp-kapp" */ 'components/core/kapp/Kapp.mdx'
    ),
  'components/core/oauth_client/OAuthClient.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-oauth-client-o-auth-client" */ 'components/core/oauth_client/OAuthClient.mdx'
    ),
  'components/core/profile/Profile.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-profile-profile" */ 'components/core/profile/Profile.mdx'
    ),
  'components/core/security_definition/SecurityDefinition.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-security-definition-security-definition" */ 'components/core/security_definition/SecurityDefinition.mdx'
    ),
  'components/core/space/Space.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-space-space" */ 'components/core/space/Space.mdx'
    ),
  'components/core/team/Team.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-team-team" */ 'components/core/team/Team.mdx'
    ),
  'components/core/submission/Submission.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-submission-submission" */ 'components/core/submission/Submission.mdx'
    ),
  'components/core/webhook_job/WebhookJob.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-webhook-job-webhook-job" */ 'components/core/webhook_job/WebhookJob.mdx'
    ),
  'components/core/user/UserForm.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-user-user-form" */ 'components/core/user/UserForm.mdx'
    ),
  'components/core/webhook/Webhook.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-core-webhook-webhook" */ 'components/core/webhook/Webhook.mdx'
    ),
  'components/form/defaults/Components.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-defaults-components" */ 'components/form/defaults/Components.mdx'
    ),
  'components/table/defaults/Components.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-table-defaults-components" */ 'components/table/defaults/Components.mdx'
    ),
}
